import { render, staticRenderFns } from "./PageError404.vue?vue&type=template&id=32de0582&scoped=true&"
import script from "./PageError404.vue?vue&type=script&lang=js&"
export * from "./PageError404.vue?vue&type=script&lang=js&"
import style0 from "./PageError404.vue?vue&type=style&index=0&id=32de0582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32de0582",
  null
  
)

export default component.exports